import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections} from "components";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import TextField from "@material-ui/core/TextField";
import {Button} from "reactstrap";
import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import {getAvCenterTabFromLocation, getHighlightPkeyFromLocation} from "utilities/avCenterHighlight";
import {avCenterAuditLabel} from "utilities/avCenterAudit";

const breadcrumbStatic = [{
	name: "AV Center",
	url: '/managers/av_center',
	icon: 'dashboard'
}];

export default class AvCenter extends Framework.Components.View {
	constructor(props) {
		super(props);
		const tab = getAvCenterTabFromLocation(props.history, 'renewal_removals');
		this.state = {
			tab,
			customerSearch: '',
			activity: [],
			activityLoading: true,
		};
	}

	componentDidMount() {
		this.syncFromLocation();
		this.loadActivity();
	}

	loadActivity = async () => {
		this.setState({activityLoading: true});
		try {
			const model = new API.BuildClass(Types.Av_Center_Audit._name, API.RequestType.READ_ALL);
			const rows = await model.submit(null, 'GET_ALL');
			this.setState({activity: Array.isArray(rows) ? rows : [], activityLoading: false});
		} catch (err) {
			this.setState({activity: [], activityLoading: false});
		}
	};

	componentDidUpdate(prevProps) {
		if (prevProps.history?.location?.hash !== this.props.history?.location?.hash) {
			this.syncFromLocation();
		}
	}

	syncFromLocation = () => {
		const tab = getAvCenterTabFromLocation(this.props.history, 'renewal_removals');
		if (tab !== this.state.tab) {
			this.setState({tab});
		}
	};

	handleTabChange = (event, value) => {
		const highlightPkey = getHighlightPkeyFromLocation(this.props.history);
		let hash = `#${value}`;
		if (highlightPkey) {
			hash += `?pkey=${highlightPkey}`;
		}
		this.props.history.replace({pathname: '/managers/av_center', hash});
		this.setState({tab: value});
	};

	openCustomerAvCenter = () => {
		const id = String(this.state.customerSearch || '').trim();
		if (!id) {
			return;
		}
		this.props.history.push(`/customers/${id}#av-center`);
	};

	render() {
		let {history} = this.props;
		let {tab} = this.state;
		return(
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbStatic} history={history}/>
				<div className="row mb-3">
					<div className="col-md-4 d-flex align-items-end">
						<TextField
							label="Customer # (open AV Center)"
							value={this.state.customerSearch}
							onChange={(e) => this.setState({customerSearch: e.target.value})}
							fullWidth
						/>
						<Button className="ml-2 mb-2" color="primary" size="sm" onClick={this.openCustomerAvCenter}>
							Open
						</Button>
					</div>
				</div>
				<ReactTable
					data={this.state.activity}
					loading={this.state.activityLoading}
					columns={[
						{Header: 'When', accessor: 'created', id: 'created'},
						{Header: 'Who', accessor: 'actor_name', id: 'actor_name'},
						{
							Header: 'Customer',
							id: 'customer',
							accessor: (row) => row.customer_name || (row.customer ? `#${row.customer}` : '-'),
							Cell: (props) => props.original.customer
								? <Link to={`/customers/${props.original.customer}#av-center`}>{props.value}</Link>
								: props.value,
						},
						{
							Header: 'Action',
							id: 'action',
							accessor: (row) => avCenterAuditLabel(row.action),
						},
						{Header: 'Result', accessor: 'outcome', id: 'outcome'},
						{Header: 'Detail', accessor: 'detail', id: 'detail'},
					]}
					defaultPageSize={8}
					className="-striped -highlight mb-3"
					showPagination={this.state.activity.length > 8}
					noDataText="No AV Center activity yet"
				/>
				<Tabs value={tab} onChange={this.handleTabChange} component={'div'}>
					<Tab label="Renewal Removals" value="renewal_removals"/>
					<Tab label="Upcoming 30 Days" value="upcoming_30"/>
					<Tab label="Recently Expired" value="recently_expired"/>
					<Tab label="Unmatched Stripe" value="unmatched_stripe"/>
					<Tab label="Renewal Emails" value="renewal_keys"/>
				</Tabs>
				<div className={"row"} style={{ marginTop: 16 }}>
					<div className={"col"}>
						{tab === 'renewal_removals' && (
							<Collections.InactiveAvSubscriptions history={history}/>
						)}
						{tab === 'upcoming_30' && (
							<Collections.AvUpcomingRenewals history={history} window="upcoming"/>
						)}
						{tab === 'recently_expired' && (
							<Collections.AvUpcomingRenewals history={history} window="recently_expired"/>
						)}
						{tab === 'unmatched_stripe' && (
							<Collections.StripeAvUnmatched history={history}/>
						)}
						{tab === 'renewal_keys' && (
							<Collections.AvRenewalDistributedKeys history={history}/>
						)}
					</div>
				</div>
			</div>
		)
	}
}
